import { render, staticRenderFns } from "./fleetDashboard.vue?vue&type=template&id=23c0255c&scoped=true"
import script from "./fleetDashboard.vue?vue&type=script&lang=js"
export * from "./fleetDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0255c",
  null
  
)

export default component.exports